var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPaper = function SvgPaper(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 91,
    viewBox: "0 0 127 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1739 90.1929H16.4784",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8424 74.5737C94.6316 78.5715 92.8901 82.3362 89.9768 85.0916C87.0635 87.8471 83.2007 89.3832 79.1847 89.3832C75.1687 89.3832 71.3058 87.8471 68.3925 85.0916C65.4792 82.3362 63.7377 78.5715 63.527 74.5737H0.809875C0.809875 76.6248 1.21515 78.6558 2.00257 80.5508C2.78998 82.4457 3.94411 84.1675 5.39907 85.6179C6.85402 87.0682 8.5813 88.2187 10.4823 89.0036C12.3833 89.7885 14.4207 90.1925 16.4784 90.1925",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8423 74.5741V16.4263",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1577 16.4259C32.1577 12.2835 33.8084 8.31084 36.7468 5.38176C39.6853 2.45267 43.6706 0.807129 47.8261 0.807129",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.511 0.807129H47.8261",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8423 16.4262C95.0531 12.4284 96.7946 8.66371 99.7079 5.90825C102.621 3.1528 106.484 1.6167 110.5 1.6167C114.516 1.6167 118.379 3.1528 121.292 5.90825C124.205 8.66371 125.947 12.4284 126.158 16.4262H94.8423Z",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1577 16.4263V74.5741",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9865 24.2407H71.3342",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1739 24.2407H87.0027",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0027 32.0557H55.6658",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8261 32.0557H39.9865",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9865 39.8594H79.1739",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9865 51.1406H87.0027",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6658 58.9443H87.0027",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9865 58.9443H47.8261",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9865 66.7593H71.3342",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1739 66.7593H87.0027",
    stroke: "#2D0AEA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPaper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paper.d4226d402fe121ca47169b0a830197b6.svg";